import { render } from "./TheTopNavigation.vue?vue&type=template&id=87f3297e"
import script from "./TheTopNavigation.vue?vue&type=script&lang=js"
export * from "./TheTopNavigation.vue?vue&type=script&lang=js"

import "./TheTopNavigation.vue?vue&type=style&index=0&id=87f3297e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__